import React from "react";

const DatasetTabs = ({ datasets, activeDataset, configByDataset, onChange, disabled }) => (
  <div className="flex flex-wrap gap-2">
    {datasets.map((dataset) => {
      const theme = configByDataset[dataset.id]?.theme;
      const isActive = dataset.id === activeDataset;

      return (
        <button
          key={dataset.id}
          type="button"
          onClick={() => onChange(dataset.id)}
          disabled={disabled}
          className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
            isActive
              ? theme?.tabActive
              : "border-slate-800 bg-slate-900/70 text-slate-400 hover:border-slate-700 hover:bg-slate-800 hover:text-slate-100"
          }`}
        >
          <span className={`h-2 w-2 rounded-full ${theme?.dot || "bg-slate-400"}`} />
          <span>{dataset.name}</span>
        </button>
      );
    })}
  </div>
);

export default DatasetTabs;
